import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from '@angular/core';

import {
    fromEvent,
    Observable,
} from 'rxjs';
import {
    map,
    startWith,
} from 'rxjs/operators';

@Component({
    selector: 'ui-password-toggle',
    template: `
    <button [disabled]="!(enabled$ | async)"
        [matTooltip]="tooltip"
        (click)="onClick()"
        mat-icon-button
        type="button">
        <mat-icon>{{!isTypePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
    </button>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiPasswordTypeToggleComponent implements OnInit {
    @Input()
    public element!: HTMLInputElement;
    @Input()
    public tooltipShow = 'Show';
    @Input()
    public tooltipHide = 'Hide';

    public isTypePassword = true;
    public enabled$!: Observable<boolean>;

    public get tooltip() {
        return this.isTypePassword ? this.tooltipShow : this.tooltipHide;
    }

    public onClick() {
        this.isTypePassword = !this.isTypePassword;
        this.element.type = this.isTypePassword ? 'password' : 'text';
    }

    ngOnInit() {
        this.enabled$ = fromEvent(this.element, 'keyup')
            .pipe(
                startWith({}),
                map(
                    () => {
                        const value = this.element.value;
                        return !!value && !/^\u2022+$/.test(value);
                    },
                ),
            );
    }
}
